export var STATUS_TYPE_MAP = {
    // Active statuses
    "draft jc": 'info',
    "approval pending": 'info',
    "awaiting for parts": 'info',
    "initiate work": 'info',
    "work started": 'info',
    "final inspection": 'info',
    "invoiced": 'info',
    "inward": 'info',
    "open": 'info',
    "inspection started": 'info',
    "started": 'info',
    "awaiting": 'info',
    // Incomplete statuses
    "in progress": 'warning',
    "rework": 'warning',
    "scheduled": 'warning',
    "rescheduled": 'warning',
    "reschedule": 'warning',
    "created": 'warning',
    "pending": 'warning',
    "waiting": 'warning',
    "work in progress": 'warning',
    "new": 'warning',
    // Error statuses
    "error": "error",
    "cancelled": "error",
    "delay": "error",
    "rejected": "error",
    'expired': "error",
    'fail': "error",
    // Success statuses
    "ready for work": "success",
    "work completed": "success",
    "workcompleted": "success",
    "inspection completed": "success",
    "ready for invoice": "success",
    "delivered": "success",
    "confirmed": "success",
    "completed": "success",
    "complete": "success",
    "confirmed/ pre jc": "success",
    "approved": "success",
    "accepted": "success",
    "vehicle delivered": "success",
    "issued": "success",
    "active": 'success',
    "pass": 'success',
    "start": 'primary',
    "pause": 'error'
};
export var getStatusColor = function (status) {
    var _status$toLocaleLower;
    var color = STATUS_TYPE_MAP[(_status$toLocaleLower = status === null || status === void 0 ? void 0 : status.toLocaleLowerCase()) !== null && _status$toLocaleLower !== void 0 ? _status$toLocaleLower : ''] || "secondary";
    return {
        variant: "outlined",
        color: color
    };
};
